import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { Paper } from '@material-ui/core'; 
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

import PaymentsDetail from '../../../../models/PaymentDetails';
import PaymentDetailsAwbs from '../../../../models/PaymentDetailsAwbs';
import PaymentDetailsAwbsServices from '../../../../models/PaymentDetailsAwbsServices';
import AddServicesTariff from '../../../../models/AddServicesTariff';

import { paymentMethodMap } from '../../../../utils/paymentMethodMap';
import { formatCurrency } from '../../../../utils/currencyFormatter';
import { getAdditionalServiceName, getAdditionalServiceDetails } from '../../../../utils/additionalServices';

import style from './payments.module.css';
import cartStyles from '../../../cart/cart.module.css';
import commonStyles from '../../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    dialog:{
      width: '100%' ,  
    },
    dialogPaper: {
      width: '100%' ,
    },
    dialogTitle: {
      paddingTop: '8px',
      paddingBottom: 0,
      borderBottom: '1px solid rgb(0, 0 ,0, 0.3)',
      marginBottom: '20px',
      paddingLeft: '28px',
      width: '100%',
      boxSizing: 'border-box',
      paddingRight: '6px'
    },
    close: {
      height: '50px',
      width: '50px'
    },
    green: {
      color: 'green'
    },
    yellow: {
      color: 'orange'
    },
    red: {
      color: 'red'
    },
    textField: {
      width: '100%',
      padding: 0,
    },
    buttonWrapper: {
      marginBottom: '20px',
      padding: '8px 24px'
    },
    button: {
      width: '150px'
    },
    root: {
      marginRight: 0,
      display: 'flex',
    },
    radioGroup: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
    placeholder: {
      marginTop: '-14px'
    },
    placeholderFocused: {
      marginTop: 0
    },
    notConfirmed: {
      marginTop: '10px'
    },
  });
  
interface PaymentDetailsModalProps {
    classes: any;
    modalOpen: boolean;
    addServicesTariff: AddServicesTariff;
    handleClose: () => void;
    handleSave: () => void;
    payments: PaymentsDetail;
    status: string;
    disabled: boolean;
    reason: string;
    weight: number;
    handleChange: (event: any) => void;
    onChangeReason: (event: any) => void;
};

const paymentDetailsModal = ( props: PaymentDetailsModalProps ) => {

  const { classes } = props;
  const paymentInfo: string = props.payments.payment_info ? props.payments.payment_info + '; ' : '';

  return (
    <Dialog
      open={ props.modalOpen }
      onClose={ props.handleClose }
      aria-labelledby="form-dialog-title"
      maxWidth={ 'md' }
      className={ classes.dialog}
      classes={{ paper: classes.dialogPaper }}
    >
      <DialogTitle className={ classes.dialogTitle } id="form-dialog-title">
        <div className={ style.wrapperTitle }>
          <span className={ style.titleText }>Payment Details</span>
          <IconButton aria-label="Close" className={ classes.close } onClick={ props.handleClose }>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent className={ classes.actionStyle }>
        <div>
          <div className={ style.info }>
            <div className={ style.LabelText }>{ paymentMethodMap[props.payments.payment_type_name] } :</div>
            <span>{ paymentInfo }</span> Paid amount: { formatCurrency(props.payments.total_amount , 2, '$') }
          </div>
          <div className={ style.info }>
            <div className={ style.LabelText }>User ID :</div>
            { props.payments.first_name } { props.payments.last_name }
          </div>     
        </div>

        <div className={ `${ commonStyles.wrapper }` }>
          <h3 className={ `${ commonStyles.header }` }> Payment Breakdown</h3>
          <MaterialTable 

            components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}

            columns={[
              { title: 'AirwayBill', field: '', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                render: (rowData: PaymentDetailsAwbs) => {
                  return (<span>{ rowData.awb_code }-{ rowData.awb_number }</span>)
                }
              },
              { title: 'Fee', field: '', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                render: (rowData: PaymentDetailsAwbs) => {

                  const fees: Array<JSX.Element> = rowData.services.map((service: PaymentDetailsAwbsServices, index: number) => (
                    <div key={ index } className={ cartStyles.feeName }>
                      { getAdditionalServiceName(service.type) }:
                      { service.type === 'other' || service.type === 'gha_adjust' ? ' ' + service.params.reason : '' }
                    </div>
                  ));
                
                  return <div>{ fees }</div>;
                }
              },
              { title: 'Details', field: 'details', cellStyle: { paddingTop: '10px', verticalAlign: 'top' },
                render: (rowData: PaymentDetailsAwbs) => {

                  const dues: Array<JSX.Element> = rowData.services.map((service: PaymentDetailsAwbsServices, index: number) => (
                    <div key={ index } className={ cartStyles.dueRow }>
                      <div>{ getAdditionalServiceDetails(service, props.weight) }</div>
                    </div>
                  ));

                  return <div>{ dues }</div>;
                }
              },
              { title: 'Amount', field: '', cellStyle: { paddingTop: '10px',verticalAlign: 'top', textAlign: 'right' },
                render: (rowData: PaymentDetailsAwbs) => {

                  const amount: Array<JSX.Element> = rowData.services.map((service: PaymentDetailsAwbsServices, index: number) => (
                    <div key={ index } className={ `${ cartStyles.dueRow } ${ commonStyles.fJustifyEnd }` }>
                      <div>$</div> 
                      <div>{ formatCurrency(service.amount, 2,) }</div>
                    </div>
                  ));

                  return (
                    <div>
                      { amount }
                      <div className={ `${ cartStyles.dueRow } ${ cartStyles.dueSumRow } ${ commonStyles.fJustifyEnd }` }>
                        <div>$</div> 
                        <div>{ formatCurrency(rowData.total_amount, 2,) }</div>
                      </div>
                    </div>
                  )
                }
              }		
            ]}

            data = { props.payments.awbs }

            options = {{
              paging: false,
              showTitle: false,
              toolbar: false,
              headerStyle: {
                backgroundColor: 'var(--tbl_head_bkg)',
                color: 'var(--tbl_head_color)',
                zIndex: 2,
              }      
            }}
          />
          <div className={ style.total }>{ formatCurrency(props.payments.total_amount , 2, '$') }</div>
        </div>       

        <RadioGroup
          aria-label="paidConfirm"
          name="paidConfirm"
          value={ props.status }
          onChange={ props.handleChange }
          className={ classes.radioGroup }
        >
          <FormControlLabel
            value="confirmed"
            label={ <Typography className={ classes.green }>Confirmed</Typography> }
            control={ <Radio className={ classes.green } checkedIcon={ <RadioButtonCheckedIcon className={ classes.green } /> } /> }
            disabled={ props.disabled }
            className={ classes.green }
          />
          <FormControlLabel
            value="pending"
            control={ <Radio className={ classes.yellow } checkedIcon={ <RadioButtonCheckedIcon className={ classes.yellow } /> }/> }
            label={ <Typography className={ classes.yellow }>Pending confirmation</Typography> }
            className={ classes.yellow }
            disabled={ props.disabled }
          />
          <FormControlLabel
            value="canceled"
            classes={{root: classes.root}}
            control={ <Radio className={ classes.red } checkedIcon={ <RadioButtonCheckedIcon className={ classes.red } /> }/> }
            label={
              <div className={ style.displayFlex }>
                <Typography className={ classes.red }>Not Confirmed</Typography>
                <div></div>
              </div>
            }
            className={ classes.red }
            disabled={ props.disabled }
          />
        </RadioGroup>
          { props.status === 'canceled' &&
          <div className= {`${classes.notConfirmed} ${classes.inputWrapper}`}>
            <div className={commonStyles.inputLabel}>Define the reason for not confirming the payment</div>
            <TextField
              value={ props.reason }
              variant="outlined"
              className={ classes.textField }
              label=''
              multiline
              onChange={ props.onChangeReason } 
              inputProps={{ style: { padding: '4px'} }}
              InputLabelProps={{ classes: {
                  root: classes.placeholder,
                  focused: classes.placeholderFocused
                } }}
              />
            </div>
          }
      </DialogContent>
      <DialogActions className={ classes.buttonWrapper } >
        <Button onClick={ props.handleSave } color="primary"  variant="contained" className={ classes.button } disabled={ props.disabled }>Save</Button>    
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(paymentDetailsModal);